export const compareData = (data1: any, data2: any): boolean => {
  return JSON.stringify(data1) !== JSON.stringify(data2)
}
